import { jsonMember, jsonObject } from 'typedjson';
import { RefundType } from '../../enums/refund-type';
import { RefundStatus } from '../../enums/refund-status';
import { RefundNumber } from '../../types/refund-number';
import { Nillable } from '@web/utils';
import { OrderRefundInvoiceResponse } from './order-refund-invoice.response';

@jsonObject
export class OrderRefundCollectionItemResponse {
  @jsonMember(String)
  public readonly type!: RefundType;

  @jsonMember(String)
  public readonly status!: RefundStatus;

  @jsonMember(String)
  public readonly number!: RefundNumber;

  @jsonMember(String)
  public readonly description!: string;

  @jsonMember(Number)
  public readonly refundedPrice!: number;

  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonMember(Date)
  public readonly finalizedAt?: Nillable<Date>;

  @jsonMember(Date)
  public readonly cancelledAt?: Nillable<Date>;

  @jsonMember(OrderRefundInvoiceResponse)
  public readonly invoice?: Nillable<OrderRefundInvoiceResponse>;
}
